import React from 'react';
import {identity} from 'lodash';
import {Autocomplete} from '@material-ui/lab';
import PropTypes from 'prop-types';

import styles from './AutocompleteFields.scss';
import TextField from './TextField';
import CloseIcon from '../icons/CloseIcon';

export default function AutocompleteField(props) {
    const {
        placeholder,
        options,
        value,
        error,
        InputProps,
        formatter = identity,
        ...restProps
    } = props;

    return (
        <Autocomplete
            autoComplete
            includeInputInList
            getOptionLabel={(option) => option && formatter(option.label || option)}
            options={options}
            closeIcon={value && value.length
                ? (
                    <CloseIcon />
                )
                : null}
            renderInput={({autoComplete, ...params}) => (
                <TextField
                    {...params}
                    {...InputProps}
                    error={error}
                    fullWidth
                    isAutoCompleteField
                    placeholder={value && value.length ? '' : placeholder}
                />
            )}
            ListboxProps={{
                classes: {root: styles.list}
            }}
            value={value}
            {...restProps}
        />
    );
}

AutocompleteField.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.shape({
                label: PropTypes.string,
            }),
            PropTypes.string,
        ])
    ),
    placeholder: PropTypes.string,
    formatter: PropTypes.func,
};

AutocompleteField.defaultProps = {
    options: [],
    placeholder: '',
    formatter: identity,
};




// WEBPACK FOOTER //
// ./src/components/controls/fields/AutocompleteField.jsx